var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createTheme } from '@mui/material/styles';
import { buttonCustomization } from './components/button';
import { inputCustomization } from './components/input';
var defaultTheme = createTheme();
var theme = createTheme({
    typography: {
        fontFamily: ['"Inter", "sans-serif"'].join(','),
        h1: {
            fontSize: defaultTheme.typography.pxToRem(48),
            fontWeight: 600,
            lineHeight: 1.2,
            letterSpacing: -0.5,
        },
        h2: {
            fontSize: defaultTheme.typography.pxToRem(36),
            fontWeight: 600,
            lineHeight: 1.2,
        },
        h3: {
            fontSize: defaultTheme.typography.pxToRem(30),
            lineHeight: 1.2,
        },
        h4: {
            fontSize: defaultTheme.typography.pxToRem(24),
            fontWeight: 600,
            lineHeight: 1.5,
        },
        h5: {
            fontSize: defaultTheme.typography.pxToRem(20),
            fontWeight: 600,
        },
        h6: {
            fontSize: defaultTheme.typography.pxToRem(18),
            fontWeight: 600,
        },
        subtitle1: {
            fontSize: defaultTheme.typography.pxToRem(18),
        },
        subtitle2: {
            fontSize: defaultTheme.typography.pxToRem(14),
            fontWeight: 500,
        },
        body1: {
            fontSize: defaultTheme.typography.pxToRem(14),
        },
        body2: {
            fontSize: defaultTheme.typography.pxToRem(14),
            fontWeight: 400,
        },
        caption: {
            fontSize: defaultTheme.typography.pxToRem(12),
            fontWeight: 400,
        },
    },
    palette: {
        primary: {
            main: '#003366',
            light: '#6699CC',
        },
        background: {
            default: '#ffffff',
        },
        text: {
            primary: '#000000',
        },
        grey: {
            400: '#bdbdbd',
            500: '#9e9e9e',
        },
    },
    components: __assign(__assign({}, buttonCustomization), inputCustomization),
});
export default theme;
